export const FETCH_GROUPS_SET_PENDING = 'FETCH_GROUPS_SET_PENDING';
export const CREATE_GROUP_SET_PENDING = 'CREATE_GROUP_SET_PENDING';
export const UPDATE_GROUP_SET_PENDING = 'UPDATE_GROUP_SET_PENDING';
export const DELETE_GROUP_SET_PENDING = 'DELETE_GROUP_SET_PENDING';
export const DELETE_GROUP_SET_MODAL_VISIBLE = 'DELETE_GROUP_SET_MODAL_VISIBLE';
export const NEW_GROUP_SET_MODAL_VISIBLE = 'NEW_GROUP_SET_MODAL_VISIBLE';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const SET_DATA = 'SET_DATA';
